
<div class="sub-menu menu-build" *ngIf="!unika">
    <ul class="sub-menu-content">
        <li *ngIf="this.zones">
            <div *ngFor="let zone of this.zones  | sortNumber: 'title': true" class="zone">
                <div class="zone-holder">
                    <h4 *ngIf="zone.title !== 'undefined'">{{ zone.title}}</h4>
                    <div class="build" *ngFor="let list of zone.list | rankingNum: 'ranking'">
                        <span href="javascript:;">
                            <div class="title">
                                {{ list.name }}
                            </div>
                        </span>
                            <ul class="menu-list-holder">
                                <li *ngFor="let item of list.floors">
                                    <a class="floor-link" *ngIf="item.floor.panoramaView"
                                        (click)='viewBuildDetailsMenu(item, "floor")' href="javascript:;">{{ 'FLOOR' | translate }}
                                        {{ item.floor.number }}
                                        {{ item.floor.freeText }}
                                    </a>
                                </li>
                            </ul>
                    </div>
                </div>
            </div>
        </li>
    </ul>
</div>
<div class="sub-menu menu-build" *ngIf="unika">
    <ul class="sub-menu-content floor-holder">
        <li *ngIf="this.zones">
            <div *ngFor="let zone of this.zones | sortNumber: 'title': true" class="zone">
                <div class="zone-holder">
                    <!-- <h4 *ngIf="zone.title !== 'undefined'">{{ zone.title}}</h4> -->
                    <div class="build" *ngFor="let list of zone.list | rankingNum: 'ranking'">
                        <span href="javascript:;" class="title-holder" (click)="editItem(list)">
                            <div *ngIf="this.currentLanguage === 'he'" class="title">
                                {{ list.name }}
                            </div>
                            <div *ngIf="this.currentLanguage === 'en'" class="title">
                                {{ list.nameEn }}
                            </div>
                            <div class="icon-holder"></div>
                        </span>
                        <div @anim *ngIf="floorsShow && list.id === itemToEdit.id ">
                            <span class="floor-note">{{ 'FLOOR' | translate }}</span>
                            <ul class="menu-list-holder">
                                <li *ngFor="let item of list.floors" class="particular-floor">
                                    <a class="floor-link" *ngIf="item.floor.panoramaView"
                                        (click)='viewBuildDetailsMenu(item, "floor")' href="javascript:;">
                                        {{ item.floor.number }}
                                        <!-- {{ item.floor.freeText }} -->
                                    </a>
                                </li>
                            </ul>
                        </div>

                    </div>
                </div>
            </div>
        </li>
    </ul>
</div>
